import { useEffect } from "react";
import { useSEO } from "@/hooks/useSEO";
import { useSettings } from "@/hooks/useSettings";
import { telHref } from "@/lib/api";

const SECTIONS = [
  {
    title: "1. რა ინფორმაციას ვაგროვებთ",
    text: "განაცხადის ფორმის შევსებისას ვაგროვებთ: სახელსა და გვარს, ტელეფონის ნომერს, სასურველ ავტომობილსა და შენს კომენტარს. ეს ინფორმაცია გვჭირდება მხოლოდ იმისთვის, რომ დაგიკავშირდეთ და შეგირჩიოთ შესაბამისი ავტომობილი.",
  },
  {
    title: "2. როგორ ვიყენებთ ინფორმაციას",
    text: "შეგროვილი მონაცემები გამოიყენება ექსკლუზიურად შენთან საკონტაქტოდ და იჯარის ხელშეკრულების მომზადებისთვის. ჩვენ არ ვყიდით და არ ვაწვდით შენს პირად ინფორმაციას მესამე მხარეებს მარკეტინგული მიზნებით.",
  },
  {
    title: "3. მონაცემების შენახვა და დაცვა",
    text: "შენი მონაცემები ინახება დაცულ სისტემებში და მათზე წვდომა აქვს მხოლოდ იმ თანამშრომლებს, ვინც შენს განაცხადზე მუშაობს. ვინახავთ ინფორმაციას მხოლოდ იმდენი ხნით, რამდენიც საჭიროა მომსახურების გასაწევად.",
  },
  {
    title: "4. შენი უფლებები",
    text: "გაქვს უფლება მოითხოვო შენი პირადი მონაცემების ნახვა, გასწორება ან წაშლა ნებისმიერ დროს. ამისთვის დაგვიკავშირდი ტელეფონით ან ელფოსტით — ვუპასუხებთ მოთხოვნას გონივრულ ვადაში.",
  },
  {
    title: "5. ცვლილებები პოლიტიკაში",
    text: "კონფიდენციალურობის პოლიტიკა შეიძლება დროდადრო განახლდეს. არსებითი ცვლილებების შემთხვევაში ვაქვეყნებთ განახლებულ ვერსიას ამ გვერდზე.",
  },
  {
    title: "6. კონტაქტი",
    contact: true,
  },
];

export default function Privacy() {
  const settings = useSettings();
  const custom = (settings.privacy_text || "").trim();
  const phone = settings.phone || "591 063 123";
  const email = settings.email || "taxiparkgeorgia@gmail.com";
  useSEO({
    title: "კონფიდენციალურობის პოლიტიკა | taxipark.ge",
    description: "taxipark.ge-ის კონფიდენციალურობის პოლიტიკა — როგორ ვინახავთ და ვიყენებთ შენს მონაცემებს.",
    path: "/privacy",
  });

  return (
    <main data-testid="privacy-page" className="pt-28 pb-8">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <p className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] font-semibold mb-3">დოკუმენტი</p>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-white">კონფიდენციალურობის პოლიტიკა</h1>
        <p className="text-sm text-gray-500 mt-4">ბოლო განახლება: 2026 წელი</p>
        <div className="mt-12 space-y-10">
          {custom ? (
            custom.split("\n\n").map((p, i) => (
              <p key={i} className="text-gray-400 leading-relaxed whitespace-pre-line" data-testid={`privacy-custom-${i}`}>{p}</p>
            ))
          ) : (
            SECTIONS.map((s, i) => (
              <section key={s.title} data-testid={`privacy-section-${i}`}>
                <h2 className="text-xl font-semibold text-white mb-3">{s.title}</h2>
                {s.contact ? (
                  <p className="text-gray-400 leading-relaxed">
                    კონფიდენციალურობასთან დაკავშირებული ნებისმიერი კითხვისთვის მოგვწერე{" "}
                    <a href={`mailto:${email}`} data-testid="privacy-email" className="text-[#E5C378] underline-offset-4 hover:underline">{email}</a>
                    -ზე ან დაგვირეკე{" "}
                    <a href={telHref(phone)} data-testid="privacy-phone" className="text-[#E5C378] underline-offset-4 hover:underline">{phone}</a>
                    -ზე.
                  </p>
                ) : (
                  <p className="text-gray-400 leading-relaxed">{s.text}</p>
                )}
              </section>
            ))
          )}
        </div>
      </div>
    </main>
  );
}
